// extracted by mini-css-extract-plugin
module.exports = {"MuiInput-root":"Input_MuiInput-root__I4niw","dark":"Input_dark__bFf0v"};